/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from "@emotion/core";
import styled from "@emotion/styled";

import { Heading } from "./UI/Typoraphy";

const Image = styled.figure(
  {
    borderRadius: "0 2rem 2rem 2rem",
    overflow: "hidden",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  (props) => ({
    "& > img": {
      height: props.height || "auto",
      width: props.width || "100%",
    },
  })
);

const Gallery = ({ title, images, style, height, width, maxWidth }) => {
  return (
    <div css={{ ...style }}>
      <Heading level={3} style={{ marginBottom: "4rem" }}>
        {title}
      </Heading>
      <div
        css={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gridTemplateRows: "1fr 1fr",
          gridGap: "2rem",
          gridTemplateAreas: `"k1 k2" 
             "k1 k3"
             "k4 k3"`,
          height,
        }}
      >
        {images.map((image, i) => (
          <Image
            key={i}
            height={i % 2 === 0 ? "100%" : "auto"}
            width={i % 2 !== 0 ? "100%" : "auto"}
            css={{ gridArea: `k${i + 1}` }}
          >
            <img src={image.src} alt={image.alt} />
          </Image>
        ))}
      </div>
    </div>
  );
};

export default Gallery;
